import * as log from '@/model/util/log/Logger'
import { getWidth } from '@/model/util/dom/domWindow'

// モバイル用レイアウトのwidthの最大値
const MOBILE_MAX_WIDTH = 767

/**
 * モバイルレイアウトかどうか
 * @returns true: モバイルレイアウト、false: PC用レイアウト
 */
const isMobile = () => {
  const width = getWidth()
  log.debug(`isMobile width: ${width}`)

  return width <= MOBILE_MAX_WIDTH
}

export { isMobile }
